var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "create-courier bg-white"
  }, [_c('div', {
    staticClass: "flex justify-between items-start shadow-border-b mdmax:flex-col"
  }, [_c('div', {
    staticClass: "flex-1 shadow-border-r"
  }, [_c('div', {
    staticClass: "p-6 shadow-border-b mdmax:shadow-border-b mdmax:flex-auto mdmax:w-full"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Info Kurir")]), _c('div', {
    staticClass: "mb-6 w-44"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "ID",
      "disabled": true
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Nama",
      "placeholder": "Masukan nama kurir"
    },
    model: {
      value: _vm.payloads.name,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "name", $$v);
      },
      expression: "payloads.name"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Jenis Kelamin")]), _c('CustomSelect', {
    attrs: {
      "options": _vm.genderList,
      "default": _vm.selectedGender,
      "optionLabel": "label",
      "placeholder": "Pilih jenis kelamin"
    },
    model: {
      value: _vm.selectedGender,
      callback: function ($$v) {
        _vm.selectedGender = $$v;
      },
      expression: "selectedGender"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "No Handphone",
      "placeholder": "Masukan no handphone"
    },
    model: {
      value: _vm.payloads.phone_number,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "phone_number", $$v);
      },
      expression: "payloads.phone_number"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Email",
      "placeholder": "Masukan email"
    },
    model: {
      value: _vm.payloads.email,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "email", $$v);
      },
      expression: "payloads.email"
    }
  })], 1), _c('div', {
    staticClass: "mb-6 text-left relative"
  }, [_vm._m(0), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "withIcon": "",
      "type": "text",
      "placeholder": "Kota / Kecamatan / Kode POS Pengirim"
    },
    on: {
      "input": function ($event) {
        return _vm.searchCity($event);
      }
    },
    model: {
      value: _vm.destinationSearch,
      callback: function ($$v) {
        _vm.destinationSearch = $$v;
      },
      expression: "destinationSearch"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_c('Search')], 1), _vm.isSearching ? _c('img', {
    staticClass: "w-8 absolute top-1/2 transform -translate-y-1/2 right-2",
    attrs: {
      "src": require("@/assets/images/rolling.gif")
    }
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_vm.visibleSuggestion ? _c('div', {
    staticClass: "mt-1 z-10 border rounded-lg absolute top-full left-0 w-full bg-white"
  }, [_vm.cities ? _c('ul', {
    staticClass: "max-h-40 overflow-y-scroll"
  }, _vm._l(_vm.cities, function (city, index) {
    return _c('li', {
      key: 'city-' + index,
      staticClass: "cursor-pointer px-3 py-2 hover:bg-neutral-300",
      on: {
        "click": function ($event) {
          return _vm.selectCity(city);
        }
      }
    }, [_vm._v(" " + _vm._s(city.village) + ", " + _vm._s(city.area_display) + " ")]);
  }), 0) : _c('div', {
    staticClass: "py-4 text-center"
  }, [_vm._v("Maaf data tidak ditemukan!")])]) : _vm._e()])], 1)])]), _c('div', {
    staticClass: "p-6 shadow-border-r mdmax:shadow-border-b mdmax:flex-auto mdmax:w-full"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("KTP & SIM")]), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "No KTP",
      "placeholder": "Masukan no KTP"
    },
    model: {
      value: _vm.payloads.id_card_number,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "id_card_number", $$v);
      },
      expression: "payloads.id_card_number"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Tipe SIM")]), _c('CustomSelect', {
    attrs: {
      "options": _vm.driverLicenseTypes,
      "optionLabel": "driver_license_name",
      "placeholder": "Pilih tipe SIM"
    },
    model: {
      value: _vm.selectedLicenseType,
      callback: function ($$v) {
        _vm.selectedLicenseType = $$v;
      },
      expression: "selectedLicenseType"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "No SIM",
      "placeholder": "Masukan no SIM"
    },
    model: {
      value: _vm.payloads.driver_license_number,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "driver_license_number", $$v);
      },
      expression: "payloads.driver_license_number"
    }
  })], 1)])]), _c('div', {
    staticClass: "flex-1 p-6 mdmax:flex-auto mdmax:w-full"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Informasi Bank")]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Nama Bank")]), _c('CustomSelect', {
    attrs: {
      "options": _vm.bankCodes,
      "default": _vm.selectedBank,
      "placeholder": "Pilih nama bank",
      "optionLabel": "name"
    },
    model: {
      value: _vm.selectedBank,
      callback: function ($$v) {
        _vm.selectedBank = $$v;
      },
      expression: "selectedBank"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "No Rekening",
      "placeholder": "Masukan no rekening"
    },
    model: {
      value: _vm.payloads.bank_account,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "bank_account", $$v);
      },
      expression: "payloads.bank_account"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Pemilik Rekening",
      "placeholder": "Masukan nama pemilik rekening"
    },
    model: {
      value: _vm.payloads.bank_account_holder,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "bank_account_holder", $$v);
      },
      expression: "payloads.bank_account_holder"
    }
  })], 1)])]), _c('div', {
    staticClass: "flex gap-6 p-6 justify-end mdmax:justify-center"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Simpan",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.submit();
      }
    }
  })], 1)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_c('span', {
    staticClass: "text-system-error"
  }, [_vm._v("*")]), _vm._v("Kota / Kecamatan / Kode POS Pengirim")]);

}]

export { render, staticRenderFns }